/**
 * Authorization Roles
 */
const authRoles = {
    admin    : ['admin'],
    staff    : ['admin', 'staff'],
    user: ['admin', 'staff', 'user'],
    test: ['user'],
    onlyGuest: []
};

export default authRoles;
